import { render, staticRenderFns } from "./referrals-link-to-brought-employee.vue?vue&type=template&id=0f58ec38&scoped=true&"
import script from "./referrals-link-to-brought-employee.vue?vue&type=script&lang=js&"
export * from "./referrals-link-to-brought-employee.vue?vue&type=script&lang=js&"
import style0 from "./referrals-link-to-brought-employee.vue?vue&type=style&index=0&id=0f58ec38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58ec38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f58ec38')) {
      api.createRecord('0f58ec38', component.options)
    } else {
      api.reload('0f58ec38', component.options)
    }
    module.hot.accept("./referrals-link-to-brought-employee.vue?vue&type=template&id=0f58ec38&scoped=true&", function () {
      api.rerender('0f58ec38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/data-table/referrals-link-to-brought-employee.vue"
export default component.exports